/**
 * Simple event emitter for ward selection events
 */
export class EventService {
  private listeners: Map<string, Set<(data: any) => void>> = new Map();

  /**
   * Subscribe to an event
   */
  on(event: string, callback: (data: any) => void): () => void {
    if (!this.listeners.has(event)) {
      this.listeners.set(event, new Set());
    }
    
    this.listeners.get(event)!.add(callback);
    
    // Return unsubscribe function
    return () => {
      const callbacks = this.listeners.get(event);
      if (callbacks) {
        callbacks.delete(callback);
        if (callbacks.size === 0) {
          this.listeners.delete(event);
        }
      }
    };
  }

  /**
   * Emit an event
   */
  emit(event: string, data?: any): void {
    const callbacks = this.listeners.get(event);
    if (callbacks) {
      callbacks.forEach(callback => {
        try {
          callback(data);
        } catch (error) {
          console.error(`Error in event listener for ${event}:`, error);
        }
      });
    }
  }

  /**
   * Remove all listeners for an event
   */
  off(event: string): void {
    this.listeners.delete(event);
  }

  /**
   * Clear all listeners
   */
  clear(): void {
    this.listeners.clear();
  }
}

// Event names
export const WARD_EVENTS = {
  WARD_SELECTED: 'ward:selected',
  WARD_DESELECTED: 'ward:deselected',
  WARD_HOVERED: 'ward:hovered',
  COMPARISON_ADDED: 'comparison:added',
  COMPARISON_REMOVED: 'comparison:removed',
  COMPARISON_MODE_CHANGED: 'comparison:modeChanged',
} as const;

// Singleton instance
export const eventService = new EventService();